// A generative AI model wrote or edited portions of this file with the supervision of a human developer and careful human review.

export const DEFAULT_METRIC = "homesaleprice";

export const DATE_FORMAT = "%Y-%m-%d";

export const MISSING_VALUE = "N/A";

export const START_DATE = "2017-01-01";

/** @typedef {import("$utils/types.d.ts").Frequency} Frequency */
/** @typedef {import("$utils/types.d.ts").GeoLevel} GeoLevel */
/** @typedef {import("$utils/types.d.ts").DollarType} DollarType */
/** @typedef {import("$utils/types.d.ts").UnitType} UnitType */
/** @typedef {import("$utils/types.d.ts").Metric} Metric */

/** @type {Record<Frequency, string>} */
export const FREQ_FORMATS = {
  input: "%Y-%m-%d",
  daily: "%B %d, %Y",
  weekly: "%B %d, %Y",
  other: "%B %d, %Y",
  monthly: "%B %Y",
  quarterly: "Q%q %Y",
  annual: "%Y"
};

/** @type {Record<string, GeoLevel>} */
export const GEO_LEVELS = {
  DISTRICT: "district",
  STATE: "state",
  NATIONAL: "national"
};

/** @type {Record<string, DollarType>} */
export const DOLLAR_TYPES = {
  REAL: "real",
  NOMINAL: "nominal"
};

/** @type {Record<string, Frequency>} */
export const FREQUENCIES = {
  INPUT: "input",
  DAILY: "daily",
  WEEKLY: "weekly",
  MONTHLY: "monthly",
  QUARTERLY: "quarterly",
  ANNUAL: "annual",
  OTHER: "other"
};

/** @type {Record<string, UnitType>} */
export const UNIT_TYPES = {
  DOLLARS: "dollars",
  CREDIT_SCORE: "credit score",
  PERCENT: "percent",
  RATE_CHANGE: "rate_change"
};

/** @type {Array<Metric>} */
export const SERIES_ORDER = [
  "homesaleprice",
  "electricitybill",
  "rent",
  "healthinsurancecost",
  "childcare",
  "gasprices",
  "grocery_costs",
  "weeklyearnings",
  "tces_rate_all",
  "sl_default_rate",
  "mortgage_delinquency_rate",
  "creditcard_delinquency_rate",
  "auto_delinquency_rate",
  "average_credit_score"
];
